<template>
  <div>
    <span class="f-circle" :class="'f-circle-'+scores[pri-1]">{{scoresChar[pri-1]}}</span>

  </div>
</template>

<script>
// import _ from 'lodash';
// import { required } from "vuelidate/lib/validators";

import { mapGetters, mapState } from "vuex";
// import { EventBus } from "@/event-bus.js";
// import moment from "moment";

export default {
  name: "PRI",
  components: {

  },
  data() {
    return {
      scores :[
        'low',
            'medium',
            'high'
      ],
      scoresChar :[
        'L',
        'M',
        'H'
      ],



    };
  },
  created() {},
  mounted() {

  },
  methods(){

  },
  validations: {},
  computed: {
    ...mapGetters([]),
    ...mapState(["toggleAllCoppalse"])
  },
  watch: {

  },
  methods: {

  },
  props: {
    pri: Number
  }
};
</script>

<style>
.f-circle {
  font-family: Arial;
  /* your font family here! */
  font-weight: bold;

  border-radius: 50%;
  background-color: red;
  display: inline-block;
  padding: 4px;
  width: 30px;
  height: 30px;
  vertical-align: middle;
  color: white;
}
.f-circle-high {

  background-color: red;

}
.f-circle-low {

  background-color: green;

}
.f-circle-medium {

  background-color: orange;

}
</style>
